import styled, { css } from 'styled-components'
import { Color } from 'root-constants'
import {
  CardCvcElement,
  CardExpiryElement,
  CardNumberElement,
} from '@stripe/react-stripe-js'
import { StripeElementStyle } from '@stripe/stripe-js'
import { Button } from 'components/Button'
import cardIcon from 'assets/images/card-icon.svg'

const INPUT_TEXT_COLOR = '#b8bbc1'

export const stripeElementStyle: StripeElementStyle = {
  base: {
    color: Color.DARK,
    fontFamily: 'Avenir Next, sans-serif',
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: '51px',
    fontSmoothing: 'antialiased',
    '::placeholder': {
      color: INPUT_TEXT_COLOR,
      fontWeight: 500,
    },
  },
  invalid: {
    color: '#ff8484',
  },
}

export const commonInputStyles = css`
  color: ${Color.DARK};
  height: 51px;
  background-color: ${Color.WHITE};
  line-height: 51px;
  border-radius: 14px;
  border: 1px solid #eaeaec;
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 8px;
  padding-left: 15px;
  transition: border-color 0.2s ease-out;
  font-family: 'Avenir Next', sans-serif;

  &[data-invalid='true'],
  &.StripeElement--invalid {
    position: relative;
    border-color: #ff8484;
    background-color: #fff3f3;
  }
`

export const StyledCreditCardForm = {
  TitleContainer: styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
  `,
  PaymentInfo: styled.span`
    font-weight: 700;
    font-size: 16px;
    line-height: 43px;
  `,
  Label: styled.p`
    width: fit-content;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #c0c1ca;
    margin-bottom: 5px;
  `,
  InputContainer: styled.div`
    display: flex;
    flex-direction: column;
  `,
  CvvExpiryInputContainer: styled.div`
    display: flex;
    justify-content: space-between;
  `,
  CardExpiryContainer: styled.div`
    width: calc(50% - 5px);
  `,
  CardCvcContainer: styled.div`
    position: relative;
    width: calc(50% - 5px);
  `,
  CardNumberElement: styled(CardNumberElement)`
    ${commonInputStyles}
  `,
  CardExpiryElement: styled(CardExpiryElement)`
    ${commonInputStyles}
  `,
  CardCvcElement: styled(CardCvcElement)`
    ${commonInputStyles}

    &::after {
      content: '';
      position: absolute;
      bottom: 24px;
      right: 16px;
      width: 30px;
      height: 20px;
      background: url(${cardIcon}) no-repeat;
      background-size: contain;
    }
  `,
  CardholderInput: styled.input`
    ${commonInputStyles};
    width: 100%;
    margin-bottom: 20px;
    font-family: 'Open Sans', sans-serif;
    outline: none;
    box-shadow: none;

    ::placeholder {
      color: ${INPUT_TEXT_COLOR};
      font-weight: 500;
    }
  `,
  Button: styled(Button)`
    max-width: 320px;
    margin-top: 0;
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
    border-radius: 16px;
  `,
}
